module.exports = __webpack_public_path__ + "img/produit_10.64587e2b.png";